import React from 'react';

import {searchProcesses} from 'app/process/actions';
import {useProcesses} from 'app/process/api';
import {PROCESS_CREATE_PAGE_URL} from 'app/urls';
import {UNLIMITED_PAGE_SIZE} from 'app/utils/constants';

import {PolicyGenericObjectsSidebar} from './PolicyGenericObjectsSidebar';

type Props = {
  policyURL: string;
  policyId: number;
  onClose: () => void;
};

export const PolicyProcessesSidebar = ({
  policyId,
  policyURL,
  ...other
}: Props) => {
  const {data, refetch} = useProcesses({
    policy_id: policyId,
    fields: [
      'name',
      'url',
      'id',
      'html_url',
      'edited_at',
      'created_at',
      'can_edit',
      'current_version',
      'policies',
    ],
    ordering: 'name',
    page_size: UNLIMITED_PAGE_SIZE,
  });

  return (
    <PolicyGenericObjectsSidebar
      items={data?.results || []}
      policyId={policyId}
      policyURL={policyURL}
      contentType="proceduregroup"
      loadItems={() => {
        refetch();
        return Promise.resolve();
      }}
      searchFunction={searchProcesses}
      createURL={PROCESS_CREATE_PAGE_URL}
      {...other}
    />
  );
};
